import { render, staticRenderFns } from "./ModalExibirFotoPerfil.vue?vue&type=template&id=478a8e52&scoped=true"
import script from "./ModalExibirFotoPerfil.vue?vue&type=script&lang=js"
export * from "./ModalExibirFotoPerfil.vue?vue&type=script&lang=js"
import style0 from "./ModalExibirFotoPerfil.vue?vue&type=style&index=0&id=478a8e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a8e52",
  null
  
)

export default component.exports